import {
  RevisionHistoryActionButton,
  RevisionHistoryActionContext
} from '~src/revisionHistory/interfaces/RevisionHistoryActionContext';
import { DeleteRevisionAction } from '~src/revisionHistory/services/DeleteRevisionAction';
import { RevisionActions } from '~src/revisionHistory/services/RevisionActions';
import { IWorkbookRevision } from '~src/revisionHistoryWorkbook/serverApi/types/IWorkbookRevision';

import { PreviewWorkbookRevisionActionInstance } from '../services/PreviewWorkbookRevisionAction';


export namespace RevisionActionWorkbook {

  export function getWorkbookRevisionActionButtons(): RevisionHistoryActionButton<IWorkbookRevision>[] {
    return [
      previewWorkbookRevisionAction(),
      deleteWorkbookRevisionAction(),
      RevisionActions.downloadContentRevisionAction()
    ];
  }

  // action button factories
  function previewWorkbookRevisionAction(): RevisionHistoryActionButton<IWorkbookRevision> {
    return {
      name: 'preview',
      translate: 'preview_action',
      execute: (context: RevisionHistoryActionContext<IWorkbookRevision>) => {
        PreviewWorkbookRevisionActionInstance.openPreview(context.selectedItem);
      }
    };
  }

  function deleteWorkbookRevisionAction(): RevisionHistoryActionButton<IWorkbookRevision> {
    return {
      name: 'delete',
      translate: 'delete_action',
      execute: (context: RevisionHistoryActionContext<IWorkbookRevision>) => {
        DeleteRevisionAction.showDeleteWorkbookRevisionDialog(context.selectedItem, context);
      }
    };
  }
}
